// extracted by mini-css-extract-plugin
export var container = "_gq-0";
export var content = "_gq-3";
export var customerTitle = "_gq-4";
export var empty = "_gq-5";
export var gray = "_gq-6";
export var header = "_gq-7";
export var info = "_gq-8";
export var loading = "_gq-2";
export var loadingCard = "_gq-9";
export var oneLine = "_gq-a";
export var personName = "_gq-e";
export var pillContainer = "_gq-b";
export var selected = "_gq-1";
export var text = "_gq-c";
export var twoLines = "_gq-d";
export var unread = "_gq-f";
export var unreadIndicator = "_gq-g";